/** @jsx jsx */
import { jsx } from '@emotion/core';
import './jquery-loader';
import 'signalr';
import React, { useEffect, useState } from 'react';
import { ReduxShell,RepairCenterLogin } from '@mitchell/redux.module.apd';
import { TestLogin } from './login/TestLogin';
import { shellConfig, RepairCenter } from './navigations';
import { rootReducer, rootSagaEffects } from './store';
import i18nInstance from '../i18n';

const App = (): React.ReactElement => {
	const [shouldStartLoadingShell, setShouldStartLoadingShell] = useState(false);

	useEffect(() => {
		if (!shouldStartLoadingShell) {
			i18nInstance.then(() => {
				//// Wait for translation to load and then render the shell
				setShouldStartLoadingShell(true);
			});
		}
	});

	return shouldStartLoadingShell ? (
		<ReduxShell
			login={process.env.NODE_ENV === 'development' ? <TestLogin /> : <RepairCenterLogin />}
			reducer={rootReducer()}
			sagaEffects={rootSagaEffects}
			shellConfig={shellConfig}
			home={RepairCenter}
			isLeftNavCollapsed={true}
		/>
	) : (
		<div></div>
	);
};

export default App;
